var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAviatorMultiplierCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 29,
    viewBox: "0 0 65 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4097_288774)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4097_288774",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C8.58172 0 5 3.58172 5 8V8.34481C5 8.93194 4.74202 9.48941 4.29445 9.86941L0.705549 12.9165C-0.235183 13.7153 -0.235181 15.167 0.705551 15.9657L4.29445 19.0129C4.74202 19.3929 5 19.9504 5 20.5375V21C5 25.4183 8.58172 29 13 29H57C61.4183 29 65 25.4183 65 21V8C65 3.58172 61.4183 0 57 0H13Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C8.58172 0 5 3.58172 5 8V8.34481C5 8.93194 4.74202 9.48941 4.29445 9.86941L0.705549 12.9165C-0.235183 13.7153 -0.235181 15.167 0.705551 15.9657L4.29445 19.0129C4.74202 19.3929 5 19.9504 5 20.5375V21C5 25.4183 8.58172 29 13 29H57C61.4183 29 65 25.4183 65 21V8C65 3.58172 61.4183 0 57 0H13Z",
    fill: "#FF5876",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29445 19.0129L3.64723 19.7752L4.29445 19.0129ZM0.705549 12.9165L0.058324 12.1543L0.705549 12.9165ZM6 8C6 4.13401 9.13401 1 13 1V-1C8.02944 -1 4 3.02944 4 8H6ZM6 8.34481V8H4V8.34481H6ZM1.35277 13.6788L4.94168 10.6317L3.64723 9.10711L0.058324 12.1543L1.35277 13.6788ZM4.94168 18.2506L1.35278 15.2034L0.0583259 16.728L3.64723 19.7752L4.94168 18.2506ZM6 21V20.5375H4V21H6ZM13 28C9.13401 28 6 24.866 6 21H4C4 25.9706 8.02944 30 13 30V28ZM57 28H13V30H57V28ZM64 21C64 24.866 60.866 28 57 28V30C61.9706 30 66 25.9706 66 21H64ZM64 8V21H66V8H64ZM57 1C60.866 1 64 4.13401 64 8H66C66 3.02944 61.9706 -1 57 -1V1ZM13 1H57V-1H13V1ZM3.64723 19.7752C3.87101 19.9652 4 20.2439 4 20.5375H6C6 19.6568 5.61302 18.8206 4.94168 18.2506L3.64723 19.7752ZM0.058324 12.1543C-1.35278 13.3523 -1.35277 15.53 0.0583259 16.728L1.35278 15.2034C0.882409 14.8041 0.88241 14.0782 1.35277 13.6788L0.058324 12.1543ZM4 8.34481C4 8.63838 3.87101 8.91711 3.64723 9.10711L4.94168 10.6317C5.61302 10.0617 6 9.2255 6 8.34481H4Z",
    fill: "#FF5876",
    mask: "url(#path-1-inside-1_4097_288774)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4097_288774",
    x: -24,
    y: -24,
    width: 113,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4097_288774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4097_288774",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviatorMultiplierCard);
export default __webpack_public_path__ + "static/media/aviator-multiplier-card.9b5398178873c93ea8971e9595cc4eb4.svg";
export { ForwardRef as ReactComponent };